import React, { useState } from 'react'
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput, TextFieldProps, TextFieldVariants } from '@mui/material'
import { useTranslation } from 'react-i18next';

const TextInput = <Variant extends TextFieldVariants>(props: {
    label?: string,
    variant?: Variant;
    wrapperSx?: any,
    helperText?: string,
    inputSx?: any
} & Omit<TextFieldProps, 'variant'>) => {
    const { t } = useTranslation();
    const { onChange, className, label, fullWidth, size, wrapperSx, inputSx, error, helperText } = props
    


    const overrideOnChange = (event: any) => {
        if (onChange) {
            onChange(event)
        }
    }





    return (
        <FormControl variant="outlined" className={className} fullWidth={fullWidth} size={size} sx={wrapperSx}>
            {
                label && <InputLabel error={props.error} htmlFor="outlined-adornment-password">{ t(label ?? "")}</InputLabel>
            }
            <OutlinedInput
                id="outlined-adornment-password"
                sx={inputSx}
                error={error ?? false}
                label={label && label}
                placeholder={props.placeholder}
                
                onChange={overrideOnChange}
            />
            <FormHelperText error={error}>{helperText ?? " "}</FormHelperText>
        </FormControl>


    )
}

export default TextInput